import * as ngCore from '@angular/core'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as me from '../../feature'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Manages the authentication of the current user
 */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(parent: me.Feature) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Auth',
      parent,
      selectors: () => new Selectors(this),
    })

    const _router = ngCore.inject(router.Router)
    this.registerEffects(
      effects.executeAuth(),
      effects.cleanUpUrlAfterAuth(_router),
      effects.refreshPageIfAuthFails(),
      // We put this at the end so that it doesn't trigger before we are ready
      // to execute
      effects.startAuth(),
    )
  }
}
